import type { LayoutHandleProps } from 'layouts/Layout/LayoutHandleProps';
import { orgDashboardApiHorizonFetchJob } from 'modules/orgDashboard/api/listing/orgDashboardApiFetchJob';
import { orgDashboardPreviewJobRoute } from 'modules/orgDashboard/routing/orgDashboard.routes';
import type { OrgDashboardOrgSubLayoutHandleProps } from 'modules/orgDashboard/sub-layouts/Org/OrgDashboardOrgSubLayoutHandleProps';
import type { HorizonAppRouteLoaderArgs } from 'routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from 'routing/types/HorizonAppRouteComponentProps';

import { OrgDashboardPreviewJobPageLoadable } from './OrgDashboardPreviewJobPageLoadable';

export const handle = {
  fallbackUrlByLocaleToCurrent: true,
  darkBackground: false,
  showDesktopSearch: true,
  orgDashboardSubLayoutVariant: 'base',
} satisfies LayoutHandleProps & OrgDashboardOrgSubLayoutHandleProps;

export async function loader({
  request,
  context,
  params: { orgId, jobId },
}: HorizonAppRouteLoaderArgs<typeof orgDashboardPreviewJobRoute>) {
  const [job] = await Promise.all([
    orgDashboardApiHorizonFetchJob({ request, context })(orgId, jobId),
    OrgDashboardPreviewJobPageLoadable.load(),
  ]);

  return { job };
}

export default function OrgDashboardPreviewJobHorizonRoute({
  loaderData: { job },
}: HorizonAppRouteComponentProps<typeof loader>) {
  return <OrgDashboardPreviewJobPageLoadable key={job.id} job={job} />;
}
